import { AwarenessUser } from "./types";

const userColors = [
  "#cf222e", // Red
  "#2da44e", // Green
  "#0969da", // Blue
  "#bf3989", // Pink
  "#ec6547", // Coral
  "#bf8700", // Yellow
  "#bc4c00", // Orange
  "#8250df", // Purple
  "#003d16", // Dark Green
  "#033d8b", // Dark Blue
];

export function getUserColor(
  userId: number,
  awarenessUsers: AwarenessUser[]
): string {
  console.log("getUserColor", userId, awarenessUsers);
  const user = awarenessUsers.find((user) => user.id === userId);
  if (user && user.color) {
    console.log("Returning existing user color", user.color);
    return user.color;
  }
  const existingColors = awarenessUsers.map((user) => user.color);
  const availableColors = userColors.filter(
    (color) => !existingColors.includes(color)
  );
  if (availableColors.length > 0) {
    return availableColors[0];
  } else {
    const randomIndex = Math.floor(Math.random() * userColors.length);
    return userColors[randomIndex];
  }
}

export function stringToHslColor(
  str: string,
  s: number = 50,
  l: number = 50
): string {
  var hash = 0;
  for (var i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }

  var h = hash % 360;
  return "hsl(" + h + ", " + s + "%, " + l + "%)";
}
